import { useContext } from 'react'
import { useNavigate } from 'react-router-dom'

import PageWrapper from '/components/page-wrapper'

import HelpText from '/help/account-management-clients'
import { AppContext } from '/providers/app-context'

import Menu from '/components/account/nav-menu'
import ClientAdmin from '/components/account/clients'

const AccountManagementClients = () => {

  const navigate = useNavigate()

  const { client, user, selectedClientId } = useContext(AppContext)
  const viewingParentClient = selectedClientId == null || selectedClientId === client?.client_id
  const canManageChildClients = user?.permissions.client_admin && client?.billing_mode === "postpay" && viewingParentClient

  if (!user?.permissions.client_admin) navigate("../password")
  if (!canManageChildClients) navigate("../details")

  return (
    <PageWrapper title="Client Management" HelpText={HelpText} heading="Client Management" menu={<Menu client={client} user={user} selectedClientId={selectedClientId} />}>
      <div className='flex flex-col gap-5 overflow-y-auto'>
        <ClientAdmin />
      </div>
    </PageWrapper>
  )
}

export default AccountManagementClients
